import { ProjectApi } from "~/api/Project";

export function useProjectApi(): ProjectApi {
  const projectApi = new ProjectApi(useHttpClient());

  return projectApi;
}
